import type { FC } from "react"
// import { useLocation } from "react-router-dom"
// import { useCreation } from "ahooks-v2"
// import { useConfigModel } from "@/models"
import { isShowConfig } from "@/util/commonUtils"
// ==============================================
import Header from "@/components/Header"
import Avatar from "@/components/Header/components/Avatar"
import VerityBox from "@/components/VerityBox"
// ==============================================
// Header隐藏列表
// const headerHiddenList = ["auth", "login", "passport", "privacypolicy"]
// ==============================================
const TopLayerContainer: FC<any> = () => {
  const isShow = isShowConfig()
  // const { currentConfig } = useConfigModel()
  // const { pathname } = useLocation()

  // // 组件是否显示
  // const isComponentShow = useCreation(() => {
  //   const firstPath = pathname?.split("/")?.[1] || ""
  //   return headerHiddenList.indexOf(firstPath) < 0
  // }, [pathname])

  return (
    <>
      {/* Header1+城市select+菜单+开关 */}
      <Header />
      {/* 头像 */}
      <Avatar isShowConfig={isShow} />
      {/* 滑动解锁 */}
      <VerityBox />
    </>
  )
}

export default TopLayerContainer
